import React from 'react';
import './LoadingSpinner.css';

export interface LoadingSpinnerProps {
  /** Size of the spinner in pixels */
  size?: number;
  /** Optional CSS class name */
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 48,
  className = '',
}) => {
  const spinnerClasses = [
    'loading-spinner',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={spinnerClasses}>
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="20" stroke="var(--ui-border, #ddd3c6)" strokeWidth="4"/>
        <circle 
          cx="24" 
          cy="24" 
          r="20" 
          stroke="var(--ui-accent, #a9662a)" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeDasharray="31.416" 
          strokeDashoffset="31.416" 
          className="loading-spinner__circle"
        />
      </svg>
    </div>
  );
};
